import React, { useMemo } from 'react';
import cn from 'classnames';
import styles from './CrudExtended.scss';
import { Tooltip } from '@/Components/Tooltip/Tooltip';
import { Icons } from '@/Static/IconsRes';
import { useLocalization } from '@/Hooks';

type Props = {
  iconItems?: IconItem[];
  className?: string;
  id?: string;
};

export enum IconType {
  Create = 1,
  Edit,
  Delete,
  Copy,
  Cancel,
  Confirm,
  Print,
  Restore,
}

export type IconItem = {
  src?: string;
  icon?: IconType;
  onClick: () => void;
  active?: boolean;
  className?: string;
  message?: string;
  disabledMessage?: string;
};

export const CrudExtended = ({ iconItems, className, id }: Props) => {
  const {
    common: { Actions },
  } = useLocalization();

  const iconsMap = useMemo(() => {
    return {
      [IconType.Create]: {
        src: Icons.Add,
        message: Actions.CreateItem,
      },
      [IconType.Edit]: {
        src: Icons.Edit,
        message: Actions.EditItem,
      },
      [IconType.Delete]: {
        src: Icons.Delete,
        message: Actions.DeleteItem,
      },
      [IconType.Copy]: {
        src: Icons.Copy,
        message: Actions.CopyItem,
      },
      [IconType.Cancel]: {
        src: Icons.Cancel,
        message: Actions.CancelItem,
      },
      [IconType.Confirm]: {
        src: Icons.Confirm,
        message: Actions.ConfirmItem,
      },
      [IconType.Print]: {
        src: Icons.Printer,
        message: Actions.PrintItem,
      },
      [IconType.Restore]: {
        src: Icons.Restore,
        message: Actions.RestoreItem,
      },
    };
  }, [Actions]);

  return (
    <div className={cn(className, styles.wrapper)} id={id ?? 'crudExtended'}>
      {iconItems?.map((item) => {
        const icon = item.icon ? iconsMap[item.icon] : item;

        return (
          <Tooltip key={icon.src} text={!item.active && item.disabledMessage ? item.disabledMessage : icon.message}>
            <img
              src={icon.src}
              className={cn(styles.icon, item.className, { [styles.icon_disabled]: !item.active })}
              alt="insert"
              onClick={item.active ? item.onClick : undefined}
            />
          </Tooltip>
        );
      })}
    </div>
  );
};
